/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as PeriodEventEmitter from '../utils/period_picker/PeriodEventEmitter'
import * as RoomEventEmitter from '../utils/period_picker/RoomEventEmitter'
import * as PeopleEventEmitter from '../utils/period_picker/PeopleEventEmitter'

(function($, scope) {
  let navigate_in_calendar;
  if (!scope.Gites) { scope.Gites = {}; }
  if (!scope.Gites.Availability) { scope.Gites.Availability = {}; }
  if (!scope.Gites.Availability.Detail) { scope.Gites.Availability.Detail = {}; }

  let calendar_open = false;
  let object_type = null;
  let blocks_url = null;
  let avail_type = null;
  let object_name = null;

  let cur_params = {};

  let room_id = ''

  let refresh_timer = null;

  const displaySidebar = () => !isMobile();

  var isMobile = () => $(window).outerWidth() < 767;

  scope.Gites.Availability.Detail.init = function(config) {
    if (config == null) { config = {}; }
    ({ blocks_url } = config);
    ({ object_type } = config);
    object_name = config.advert_name;

    cur_params = config.cur_params || {}

    if (is_bnb()) {
      $bnb_rooms().select2({
        minimumResultsForSearch: -1
      });

      $bnb_rooms().change(() => {
        const val = $bnb_rooms().val()
        RoomEventEmitter.publish({ room_id: val ? parseInt(val) : val, source: "inline"})
      })
    }

    enable_form_fields();

    $(document).on('change', 'select.persons', function (e) {
      refresh_blocks(cur_params.start_date, cur_params.end_date)
    });

    refresh_blocks(cur_params.start_date, cur_params.end_date)

    PeriodEventEmitter.subscribe((payload) => {
      if (payload.source !== 'sidebar') {
        return
      }

      if (null !== payload.focusedInput) {
        return
      }

      const start_date = payload.start_date ? payload.start_date.format("DD-MM-YYYY") : null
      const end_date = payload.end_date ? payload.end_date.format("DD-MM-YYYY") : null
      update_period(start_date, end_date)
    })

    RoomEventEmitter.subscribe((payload) => {
      if (room_id == payload.room_id) {
        return;
      }

      room_id = payload.room_id

      $bnb_rooms().val(payload.room_id)
      $bnb_rooms().trigger('change')
      refresh_blocks(cur_params.start_date, cur_params.end_date)
    })

    PeopleEventEmitter.subscribe((payload) => {
      if (payload.source !== 'booking_form') {
        return
      }
      $('select.persons').val(payload.max_people)
      $('select.persons').trigger('change')
    })

    $(scope).resize(delayed_availability_calendar_refresh);

    return $(scope).resize(function() {
      if (displaySidebar() === cur_params.sidebar) { return; }
      if (refresh_timer) { clearTimeout(refresh_timer); }

      return refresh_timer = setTimeout(() => refresh_blocks(cur_params.start_date, cur_params.end_date)
      , 500);
    });
  };

  var is_bnb = () => object_type === 'bed_and_breakfast';

  // Wrappers for jquery selectors
  const $form_fields_to_disable = () => $('input.start_date, input.end_date, #sidebar_start_date, #sidebar_end_date, select.persons, form#new_contact_entry input, form#new_contact_entry textarea');
  const $calendar_wrapper = () => $('#availabilty-wrapper');
  var $bnb_rooms = () => $('#calendar_wrapper .bnb-rooms');
  var $bnb_rooms_conv = () => $('#conversation_bnb_room_id');
  const $summary = () => $('#calendar_wrapper .availability-summary');
  const $sidebar = () => $('.sidebar');
  const $sidebar_inner = () => $sidebar().find('.sidebar-inner');
  const $price_information_detail = () => $('.additional_price_details')

  const disable_form_fields = () => $form_fields_to_disable().attr('disabled', true);
  var enable_form_fields = () => $form_fields_to_disable().attr('disabled', false);

  var date_pickers_event_type = function() { if (/ipad|ipod|iphone/.test(navigator.userAgent.toLowerCase())) { return 'blur'; } else { return 'change'; } };

  var delayed_availability_calendar_refresh = function() {
    if (this.timer) { clearTimeout(this.timer); }
    return this.timer = setTimeout(reload_calendar, 2000);
  };

  const update_period_deferred = null;

  var update_period = function(start_date, end_date) {
    return refresh_blocks(start_date, end_date, cur_params.max_persons);
  };

  const selected_room = function() {
    return room_id
  };


  var refresh_blocks = function(start_date, end_date, persons) {
    const params = {
      room: selected_room(),
      start_date,
      end_date,
      max_persons: $('select.persons').val(),
      sidebar: displaySidebar()
    };

    if (_.isEqual(cur_params, params)) { return; }
    disable_form_fields();
    cur_params = params;

    return $.ajax({
      url: blocks_url,
      dataType: 'json',
      method : 'GET',
      data: params,
      success(data) {
        $('input#conversation_bookings_attributes_0_arrival_date').val(data.start_date);
        $('input#conversation_bookings_attributes_0_departure_date').val(data.end_date);

        $('select.persons, .conversation_bookings_visitors select').each(function() {
          if ($(this).select2('val') != data.persons) {
            $(this).select2('val', data.persons);
          }
        });

        // Update sidebar with new avail info / price info / etc
        $price_information_detail().html(data.price_block);
        if (data.sidebar) {
          $sidebar().replaceWith(data.sidebar);
          $sidebar_inner().affix($sidebar_inner().data());
          $sidebar_inner().data('gites.affix').handleAffix();
        } else {
          $sidebar().empty();
        }

        $(window).trigger('scroll');

        // Trigger change so datepickers are initialized again (eww)
        // @todo refactor
        $('body').trigger('change');

        avail_type = data.type;
        object_name = data.name;

        replace_availability_summary();

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({'event': 'optimize.activate'});

        if (shouldOpenCalendar(data.type)) {
          const date = data.start_date_8601 ?
            new Date(data.start_date_8601)
          :
            new Date();

          return update_calendar_with(date.getUTCFullYear(), date.getUTCMonth() + 1);
        } else {
          return $calendar_wrapper().find('.calendars ul.availabilities-calendar').remove();
        }
      }
    });
  };

  var replace_availability_summary = function() {
    if (!avail_type || (avail_type === 'unknown')) {
      $summary().html(null);
      return;
    }

    const $div = $('<div class="icon-checkmark"/>');
    const $text = $('<span />');
    $text.text(I18n.t(`availabilities.summary.${avail_type}`, {name: object_name}));
    $div.append($text);
    if ((avail_type === 'available') && !calendar_open) {
      const $link = $('<a href="#" />').text(I18n.t("availabilities.summary.open_calendar"));
      $link.click(function(e) {
        e.preventDefault();
        return reload_calendar();
      });

      $div.append($link);
    }

    if (calendar_open) {
      $calendar_wrapper().css('min-height', '360px');
    }

    return $summary().html($div);
  };

  var shouldOpenCalendar = function(type) {
    if (calendar_open) { return true; }
    return (type !== 'available') && (!is_bnb() || selected_room());
  };

  var reload_calendar = () =>
    update_calendar_with(
      $calendar_wrapper().find('.calendars .availabilities-calendar:first').data('year') || (new Date()).getUTCFullYear(),
      $calendar_wrapper().find('.calendars .availabilities-calendar:first').data('month') || ((new Date()).getUTCMonth() + 1)
    )
  ;

  const calendar_count = function() {
    if (window.innerWidth > 1024) {
      return 3;
    } else if (window.innerWidth > 480) {
      return 2;
    } else {
      return 1;
    }
  };

  var update_calendar_with = function(year, month) {

    if (is_bnb() && !selected_room()) {
      $calendar_wrapper().find('.calendars ul.availabilities-calendar').remove()
      return
    }
    calendar_open = true;
    replace_availability_summary();

    $calendar_wrapper().find('.loading-overlay').fadeIn(100);

    return $.ajax({
      url: $calendar_wrapper().data('url'),
      data: {
        // First we substract 1 from the month for modulo to work to work correctly
        // Then we add 12 to the month account for negative months
        // Then we add +1 to balance the -1
        month: (((month - 1)+ 12) % 12) + 1,
        year: year + Math.floor((month - 1) / 12),
        length: calendar_count(),
        start_date: cur_params.start_date,
        end_date: cur_params.end_date,
        room: selected_room()
      },
      dataType: 'html',
      method: 'GET',
      timeout: 10000,
      complete(data) {
        return $calendar_wrapper().find('.loading-overlay').fadeOut(100);
      },
      success(data) {
        $calendar_wrapper().find('.calendars').empty();
        $calendar_wrapper().find('.calendars').append( data );
        $calendar_wrapper().find('.nav-button.next').click(function(e) {
          if (e) { e.preventDefault(); }
          return navigate_in_calendar('next');
        });

        return $calendar_wrapper().find('.nav-button.prev').click(function(e) {
          if (e) { e.preventDefault(); }
          return navigate_in_calendar('previous');
        });
      }
    });
  };

  return navigate_in_calendar = function(direction) {
    const multiplier = (() => { switch (direction) {
      case 'previous': return -1;
      case "next": return 1;
      default: throw 'invalid direction';
    } })();

    const first_calendar = $calendar_wrapper().find('.calendars .availabilities-calendar:first');
    const skip_count = calendar_count() > 1 ? calendar_count() - 1 : 1;

    const month = parseInt( first_calendar.data('month') ) + (multiplier * skip_count);
    const year = parseInt( first_calendar.data('year') );

    return update_calendar_with(year, month);
  };
})(jQuery, global);
